const translations = {
  "en": {
    "3-month average": "3-month average",
    "5 asset classes across 3 accounts": "5 asset classes across 3 accounts",
    "Bonds": "Bonds",
    "Cash": "Cash",
    "Crypto": "Crypto",
    "Demo": "Demo",
    "ETFs": "ETFs",
    "Food & dining": "Food & dining",
    "Groceries": "Groceries",
    "May 1 – 28": "May 1 – 28",
    "Month": "Month",
    "Net worth": "Net worth",
    "Portfolio distribution": "Portfolio distribution",
    "Rent and utilities": "Rent and utilities",
    "Shopping": "Shopping",
    "Spend by category": "Spend by category",
    "Spend this month": "Spend this month",
    "Start your check-up to see yours.": "Start your check-up to see yours.",
    "Stocks": "Stocks",
    "This is just sample data": "This is just sample data",
    "This month": "This month",
    "Transit": "Transit",
    "Year to date": "Year to date"
  },
  "zh-tw": {
    "3-month average": "3 個月平均值",
    "5 asset classes across 3 accounts": "3 個帳戶涵蓋 5 種資產類別",
    "Bonds": "債券",
    "Cash": "現金",
    "Crypto": "加密貨幣",
    "Demo": "示範",
    "ETFs": "ETF",
    "Food & dining": "美食與餐飲",
    "Groceries": "雜貨",
    "May 1 – 28": "5 月 1 日至 28 日",
    "Month": "月份",
    "Net worth": "淨資產",
    "Portfolio distribution": "投資組合分配",
    "Rent and utilities": "房租與水電費",
    "Shopping": "購物",
    "Spend by category": "按類別支出",
    "Spend this month": "本月支出",
    "Start your check-up to see yours.": "開始健檢，看看你的狀況。",
    "Stocks": "股票",
    "This is just sample data": "這只是範例資料",
    "This month": "本月",
    "Transit": "交通",
    "Year to date": "年初至今"
  }
};

export default translations;
